module.exports = __webpack_public_path__ + "img/michel-polnareff.7d48185f.jpg";